import { initializeApp } from 'firebase/app';
import { getAnalytics, Analytics } from 'firebase/analytics';

// const firebaseConfig = {
//   apiKey: "AIzaSyBfHUJFU7SMULqB2yHulI5mMpF5w72x4kU",
//   authDomain: "qa---duidash.firebaseapp.com",
//   projectId: "qa---duidash",
//   storageBucket: "qa---duidash.firebasestorage.app",
//   messagingSenderId: "253824615842",
//   appId: "1:253824615842:web:38e0db8a5fd2c211af5efb",
//   measurementId: "G-WSESR5HWX6"
// };

const firebaseConfig = {
  apiKey: "AIzaSyC_5hLVcjldZAGgdTrsX0EbjI_Snwufgp8",
  authDomain: "ga4---prod---duidash.firebaseapp.com",
  projectId: "ga4---prod---duidash",
  storageBucket: "ga4---prod---duidash.firebasestorage.app",
  messagingSenderId: "920921845288",
  appId: "1:920921845288:web:372ce51e21a0593f0c4f1d",
  measurementId: "G-R2YM6GQ4S2"
};
 

const app = initializeApp(firebaseConfig);

// Only initialize analytics in browser
let analytics: Analytics | null = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { analytics };
